import { createReducer, on } from '@ngrx/store';
import { IQueueSlice, IWorkingQueuesState } from './working-queues.state';
import {
  loadQueueRows,
  loadQueueRowsFailure,
  loadQueueRowsSuccess,
  loadQueueSummaries,
  loadQueueSummariesFailure,
  loadQueueSummariesSuccess,
} from './working-queues.actions';

const emptySlice = (): IQueueSlice => ({
  summaries: [],
  summariesLoading: false,
  summariesLoaded: false,
  rows: [],
  rowsLoading: false,
  activeQueue: null,
});

export const initialState: IWorkingQueuesState = {
  liability: emptySlice(),
  claim: emptySlice(),
  recovery: emptySlice(),
};

export const workingQueuesReducer = createReducer(
  initialState,
  on(loadQueueSummaries, (state, { queueType }) => ({
    ...state,
    [queueType]: { ...state[queueType], summariesLoading: true },
  })),
  on(loadQueueSummariesSuccess, (state, { queueType, summaries }) => ({
    ...state,
    [queueType]: {
      ...state[queueType],
      summaries,
      summariesLoading: false,
      summariesLoaded: true,
    },
  })),
  on(loadQueueSummariesFailure, (state, { queueType }) => ({
    ...state,
    [queueType]: {
      ...state[queueType],
      summaries: [],
      summariesLoading: false,
      summariesLoaded: true,
    },
  })),
  on(loadQueueRows, (state, { queueType, queue }) => ({
    ...state,
    [queueType]: {
      ...state[queueType],
      rows: [],
      rowsLoading: true,
      activeQueue: queue,
    },
  })),
  on(loadQueueRowsSuccess, (state, { queueType, rows }) => ({
    ...state,
    [queueType]: { ...state[queueType], rows, rowsLoading: false },
  })),
  on(loadQueueRowsFailure, (state, { queueType }) => ({
    ...state,
    [queueType]: { ...state[queueType], rows: [], rowsLoading: false },
  }))
);
